import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "../../assets/styles/loan.module.css";
import Strings from "../../utils/stringUtil";
import { readyToGrowSteps } from "../../utils/businessLoanUtil";
import { isMobile } from "../../utils/responsiveUtil";

function ReadyToGrow() {
  return (
    <Box className={`container`} py="60px">
      <Box style={{ transform: isMobile ? "scale(1)" : "scale(0.94)" }}>
        <Typography className={styles.loanTitle} mb={"43px"}>
          {Strings.readyToGrow}
        </Typography>

        <Box
          display={"flex"}
          gap={5}
          justifyContent={"center"}
          flexWrap={"wrap"}
        >
          {readyToGrowSteps.map((step, index) => {
            return (
              <Box key={index} className={styles.growStepCard}>
                <img src={step.img} width={"100%"} alt={step.title} />
                <Typography className={styles.growStepCardTitle}>
                  {step.title}
                </Typography>
                <Typography className={styles.growStepCardDesc}>
                  {step.desc}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default ReadyToGrow;
